import { TextInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import { InputCep } from 'app/components/Input';
import { SelectUnidadeFederativa } from 'app/components/Select';
import SelectMunicipioV2 from 'app/components/Select/SelectMunicipioV2';
import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';

const Endereco = ({ values, onChange, onBlur, errors, touched }) => {
  const { cep, logradouro, numero, complemento, uf = {}, cidade = {}, bairro, referencia } =
    values?.pessoa?.endereco || {};

  const { pessoa = {} } = values;
  const [primeiraAbertura, setPrimeiraAbertura] = useState(null);

  const ufSigla = uf?.sigla;
  useEffect(() => {
    localStorage.setItem('UF', ufSigla);

    // Limpa o campo cidade apenas se a UF mudou e a cidade não pertence à nova UF
    if (
      primeiraAbertura !== null &&
      pessoa?.endereco?.cidade &&
      (!pessoa?.endereco?.cidade?.uf || pessoa?.endereco?.cidade?.uf !== ufSigla)
    )
      setPrimeiraAbertura('não nulo');
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ufSigla]);

  const handleChangeCep = (event) => {
    onChange(event);

    onChange({
      target: {
        id: 'pessoa.endereco.numero',
        value: '',
      },
    });

    onChange({
      target: {
        id: 'pessoa.endereco.complemento',
        value: '',
      },
    });

    onChange({
      target: {
        id: 'pessoa.endereco.referencia',
        value: '',
      },
    });
  };

  return (
    <>
      <Grid item xs={12}>
        <InputCep
          autoFocus
          label="CEP"
          id="pessoa.endereco.cep"
          idObject="pessoa.endereco"
          endereco={values?.pessoa?.endereco}
          handleChange={handleChangeCep}
          value={cep}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          label="Logradouro"
          id="pessoa.endereco.logradouro"
          onChange={onChange}
          value={logradouro}
          maxLength={100}
        />
      </Grid>

      <Grid item xs={6}>
        <TextInput
          fullWidth
          label="Número"
          id="pessoa.endereco.numero"
          onChange={onChange}
          value={numero}
          maxLength={50}
        />
      </Grid>

      <Grid item xs={6}>
        <TextInput
          fullWidth
          label="Complemento"
          id="pessoa.endereco.complemento"
          onChange={onChange}
          value={complemento}
          maxLength={50}
        />
      </Grid>

      <Grid item xs={6}>
        <SelectUnidadeFederativa
          fullWidth
          variant="outlined"
          label="UF"
          id="pessoa.endereco.uf"
          idObject="pessoa.endereco.uf"
          value={uf && (uf.id || uf.nome || uf)}
          handleChange={(event) => {
            const novaUf = event.target.value?.sigla || event.target.value;
            const ufAtual = uf?.sigla || uf;

            if (novaUf !== ufAtual && cidade?.id) {
              onChange({
                target: {
                  id: 'pessoa.endereco.cidade',
                  value: undefined,
                },
              });
            }
            onChange(event);
          }}
          onBlur={onBlur}
        />
      </Grid>

      <Grid item xs={6}>
        <SelectMunicipioV2
          id="pessoa.endereco.cidade"
          name="pessoa.endereco.cidade"
          label="Cidade"
          onChange={onChange}
          onBlur={onBlur}
          value={cidade}
        />
      </Grid>

      <Grid item xs={6}>
        <TextInput
          label="Bairro"
          id="pessoa.endereco.bairro"
          value={bairro}
          maxLength={100}
          onChange={onChange}
          onBlur={onBlur}
          touched={touched?.pessoa?.endereco?.bairro}
          error={errors?.pessoa?.endereco?.bairro}
        />
      </Grid>

      <Grid item xs={6}>
        <TextInput
          label="Referência"
          id="pessoa.endereco.referencia"
          value={referencia}
          onChange={onChange}
          onBlur={onBlur}
          touched={touched?.pessoa?.endereco?.referencia}
          error={errors?.pessoa?.endereco?.referencia}
          maxLength={100}
        />
      </Grid>
    </>
  );
};

const TabEndereco = () => {
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched } = formikContext;

  return <Endereco values={values} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} />;
};

export default TabEndereco;
